import React from "react";
import { Link } from "react-router-dom";
import { PageBanner } from "@/components/site/PageBanner";

const SERVICES = [
  { name: "Standard", body: "Private local rides for appointments, errands, nights out and everyday trips.", deposit: "25% deposit to confirm" },
  { name: "Airport", body: "Pickups and drop-offs timed around your flight. Add your flight number in the notes.", deposit: "25% deposit to confirm" },
  { name: "Nashville Express", body: "A private ride between the Mid-South and Nashville.", deposit: "40% deposit to confirm" },
  { name: "Custom Long Distance", body: "Planned trips beyond the usual routes, priced for the distance.", deposit: "50% deposit to confirm" },
];

export default function Services() {
  return (
    <>
    <PageBanner title="Our Services" crumb="Services" />
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-10">
      <p className="eyebrow">What we offer</p>
      <h2 className="mt-4 font-display text-3xl md:text-4xl">Every ride, personally arranged.</h2>
      <div className="gold-rule mt-8 w-40" />
      <div className="mt-16 grid gap-px overflow-hidden rounded-md border border-gold/25 bg-gold/25 md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <article key={s.name} className="rise flex flex-col bg-ink p-8 md:p-12" style={{ animationDelay: `${i * 80}ms` }} data-testid={`service-card-${i}`}>
            <h2 className="font-display text-2xl text-mist">{s.name}</h2>
            <p className="mt-4 text-[15px] leading-relaxed text-mist/80">{s.body}</p>
            <p className="mt-8 text-[14px] text-gold">{s.deposit}</p>
          </article>
        ))}
      </div>
      <section className="mt-20 grid gap-10 md:grid-cols-[1fr_1.3fr]">
        <h2 className="font-display text-3xl">How payment works</h2>
        <ul className="flex flex-col gap-4 text-[15px] leading-relaxed text-mist/85">
          <li>Every ride is quoted personally. You'll get your price by text before anything is booked.</li>
          <li>Rides on the same day or within 24 hours of pickup are paid in full up front.</li>
          <li>For other rides, the deposit above confirms your booking and the balance is due 24 hours before pickup.</li>
          <li>We accept Zelle, Apple Pay, Venmo, PayPal and Cash.</li>
        </ul>
      </section>
      <Link to="/book" data-testid="services-book-btn" className="mt-14 inline-flex min-h-[52px] items-center rounded-full bg-plum px-8 font-medium text-mist transition-colors duration-200 hover:bg-orchid">Request a ride</Link>
    </div>
    </>
  );
}
